import qs from "qs";
import { GetData } from "./Functions/SettingData";
import { prepareHeadersForGlobalFilters } from "../PagesContent/Overview/CommonFunctions";

const getSmartAlertsKPIs = async (globalFilters = {}, params) => {
  const config = {
    method: "get",
    url: "/api/alerts/v2/analytics/kpis",
    headers: prepareHeadersForGlobalFilters(globalFilters, "smartAlerts"),
    params,
  };
  return GetData(config);
};

const getSmartAlertsTimeseries = async (globalFilters = {}, params) => {
  if (params.filters) params.filters = JSON.stringify(params.filters);
  const config = {
    method: "get",
    url: "/api/alerts/v2/analytics/timeseries",
    headers: prepareHeadersForGlobalFilters(globalFilters, "smartAlerts"),
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
  };
  return GetData(config);
};

const getSmartAlertsList = async (globalFilters = {}, params) => {
  if (params.filters) params.filters = JSON.stringify(params.filters);
  if (params.sortBy) params.sortBy = JSON.stringify(params.sortBy);
  const config = {
    method: "get",
    url: "/api/alerts/v2/analytics/list",
    headers: prepareHeadersForGlobalFilters(globalFilters, "smartAlerts"),
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
  };
  return GetData(config);
};

const smartAlertsListAction = async (globalFilters = {}, params) => {
  const config = {
    method: "post",
    url: "/api/alerts/v2/analytics/list-actions",
    headers: prepareHeadersForGlobalFilters(globalFilters, "smartAlerts"),
    data: params,
  };
  return GetData(config);
};

export {
  getSmartAlertsKPIs,
  getSmartAlertsTimeseries,
  getSmartAlertsList,
  smartAlertsListAction,
};
